import {Typography} from '../typography';
import * as Styled from './modal.styles';
import {Icon} from '../icon';

export interface ModalHeaderProps {
  title: string;
  hideBottomBorder?: boolean;
  onClose?: () => void;
  className?: string;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({title, onClose, children, hideBottomBorder, className}) => (
  <Styled.ModalHeader hideBottomBorder={hideBottomBorder} className={className}>
    {title ? <Typography type="h3">{title}</Typography> : children}
    <Icon type="u_multiply" onClick={onClose} isPointer isHover />
  </Styled.ModalHeader>
);

export default ModalHeader;
